// ============================================================
// NucleosContexto.js — nome de exibição dos núcleos
//
// O identificador do núcleo ("IFCE") é chave estrangeira em users,
// attendance_logs, dispensas, solicitacoes e treinos_externos. Mudá-lo
// órfãozaria todos esses registros de uma vez, então ele é IMUTÁVEL.
//
// O que a coordenação edita é o NOME DE EXIBIÇÃO, guardado em
// nucleos/{id}.nome. Este contexto carrega o mapa uma vez e entrega a
// tradução a quem precisa mostrar — assim renomear o núcleo se reflete
// em todas as telas e relatórios sem passar prop por dez arquivos.
//
// Enquanto o mapa não chega, devolve o próprio identificador: é o mesmo
// texto que aparecia antes, então a tela nunca fica vazia nem pisca.
// ============================================================

import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { carregarNucleos } from "./firebase";

const Contexto = createContext({ nomes: {}, nomeDo: (id) => id, recarregarNucleos: () => {} });

export function NucleosProvider({ children }) {
  const [nomes, setNomes] = useState({});

  async function carregar() {
    try {
      const lista = await carregarNucleos();
      const mapa = {};
      lista.forEach((n) => { mapa[n.id] = n.nome || n.id; });
      setNomes(mapa);
    } catch {
      // Sem o mapa, nomeDo devolve o identificador — degrada para o
      // comportamento antigo em vez de quebrar a tela.
    }
  }

  useEffect(() => { carregar(); }, []);

  const valor = useMemo(
    () => ({
      nomes,
      nomeDo: (id) => (id ? nomes[id] || id : ""),
      recarregarNucleos: carregar,
    }),
    [nomes]
  );

  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>;
}

// Traduz o identificador do núcleo para o nome de exibição.
export function useNomeNucleo() {
  return useContext(Contexto).nomeDo;
}

// Para a tela de núcleos avisar que renomeou e o resto do painel
// acompanhar sem exigir recarga da página.
export function useNucleos() {
  return useContext(Contexto);
}
